(function (angular) {
    'use strict';

    angular
        .module('Toyota.Directives')
        .directive('tyScrollToError', ['$timeout', 'SmoothScrollTo', function ($timeout, SmoothScrollTo) {
            return {
                restrict: 'A',
                require: 'form',
                link: function (scope, element, attrs, ngFormCtrl) {
                    var initialized = false;
                    var disableScrollOnSubmit = attrs.tyScrollToErrorDisableScrollOnSubmit === 'true';
                    var snapToClosestSelector = attrs.tyScrollToErrorSnapToClosestSelector;

                    function bindListeners() {
                        element.bind('submit', eventHandler);
                    }

                    function unbindListeners() {
                        if (!initialized) {
                            return;
                        }

                        element.unbind('submit', eventHandler);
                    }

                    function getValidationErrorElements() {
                        return element.find(attrs.tyScrollToErrorSelector || '').filter(':visible');
                    }

                    function hasValidationErrors() {
                        return getValidationErrorElements().length > 0;
                    }

                    function eventHandler() {
                        if (disableScrollOnSubmit) {
                            return;
                        }

                        $timeout(function () {
                            if (hasValidationErrors()) {
                                var errorFieldInfos = getErrorFieldInfos();
                                var topmostErrorFieldInfo = getTopmostFieldInfo(errorFieldInfos);
                                scrollToErrorField(topmostErrorFieldInfo);
                            }

                        }, 200);
                    }

                    function getTopmostFieldInfo(fields) {
                        var topmost = null;
                        for (var field in fields) {
                            if (fields.hasOwnProperty(field)) {
                                if (!topmost) {
                                    topmost = fields[field];
                                }
                                if (fields[field].offset) {
                                    if (fields[field].offset.top < topmost.offset.top) {
                                        topmost = fields[field];
                                    } else if (fields[field].offset.top === topmost.offset.top) {
                                        if (fields[field].offset.left < topmost.offset.left) {
                                            topmost = fields[field];
                                        }
                                    }
                                }
                            }
                        }

                        return topmost;
                    }

                    function getErrorFieldInfos() {
                        var errorFieldInfos = {};

                        var $validationErrors = getValidationErrorElements();

                        var fieldNames = Object.keys(ngFormCtrl).filter(function (field) {
                            return !field.match(/^\$/);
                        });

                        var fieldSelector = fieldNames.map(function (fieldName) {
                            return '[name=\'' + fieldName + '\']';
                        }).join(',');

                        $validationErrors.each(function () {
                            var $el = $(this);
                            var $field = $el.find(fieldSelector);
                            var fieldName = $field.attr('name');

                            var $visibleEl = $field;
                            while (!$visibleEl.is(':visible')) {
                                $visibleEl = $visibleEl.parent();
                            }

                            errorFieldInfos[fieldName] = {
                                $el: $field,
                                offset: $visibleEl && $visibleEl.offset(),
                                $visibleEl: $visibleEl
                            };
                        });

                        return errorFieldInfos;
                    }

                    function scrollToErrorField(errorFieldInfo) {
                        if (!errorFieldInfo) {
                            return;
                        }

                        var $errorField = errorFieldInfo.$visibleEl;
                        var $scrollTo = snapToClosestSelector ? $errorField.closest(snapToClosestSelector) : $errorField;

                        SmoothScrollTo($scrollTo);
                    }

                    function initialize() {
                        if (initialized) {
                            return;
                        }
                        bindListeners();
                        initialized = true;
                    }

                    function uninitialize() {
                        unbindListeners();
                        initialized = false;
                    }

                    scope.$on('$destroy', uninitialize);

                    initialize();
                }
            };
        }]);
})(window.angular);